import React, { PureComponent } from 'react';
import autobind from 'autobind-decorator';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
/* Important because Foundation */
/* min-width because of flex bug on Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1088586 */
const Container = styled.div`
  margin-bottom: 33px;
`;

const StyledTextArea = styled.textarea`
  margin: 0;
  border-radius: 3px;
  box-shadow: none;
  min-width: 0;
  border-width: 1px;
  -moz-appearance: textfield;

  ${({ isValid, theme }) => css`
    ${isValid === false &&
      css`
        && {
          // this && creates extra !importance
          border-color: ${theme.colors.borderError};
        }
      `}
  `}
`;

const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.colors.borderError};
  font-size: 12px;
  margin-top: 5px;
`;
// TODO create helper regexs @kerryaustin
// /^[0-9]+\.?[0-9]{0,2}?$/ 99[].99]

class TextArea extends PureComponent {
  static propTypes = {
    validator: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.string.isRequired,
    pattern: PropTypes.object,
    inputRef: PropTypes.func,
  };

  static defaultProps = {
    validator: () => true,
    onChange: () => null,
    pattern: null,
    inputRef: () => {},
  };

  state = {
    isValid: null,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.validator && this.props.value !== nextProps.value) {
      this.validate(nextProps.validator, nextProps.value);
    }
  }

  @autobind
  onChange(event) {
    const { pattern, value, onChange } = this.props;
    if (pattern && event.target.value.length > 0) {
      if (!pattern.test(event.target.value)) {
        event.target.value = value;
      }
    }

    if (onChange) {
      onChange(event);
    }
  }

  validate(validator, value) {
    const isValid = validator(value);
    this.setState({ isValid });
  }

  render() {
    const {
      onChange,
      pattern,
      value,
      inputRef,
      errorMessage,
      ...rest
    } = this.props;
    return (
      <Container>
        <StyledTextArea
          {...rest}
          innerRef={inputRef}
          value={value}
          onChange={this.onChange}
          isValid={this.state.isValid}
        />
        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      </Container>
    );
  }
}

export default TextArea;
